import axios from "axios";

const getForeignTravelDetails = async () => {
  return axios.get("ForeignTraveller/GetForeignTravelDetails");
};

export default {
  getForeignTravelDetails,
};
